import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { LabelPipe } from '@streamamg/wordpress-lib';


@NgModule({
  declarations: [
    LabelPipe,
  ],
  exports: [
    LabelPipe,
  ],
  imports: [
    CommonModule,
    RouterModule,
  ],
})
export class SharedModule {
}
